export default __webpack_public_path__ + "static/media/boxicons.5e81160c.svg";